import { ref } from 'vue';

export const useTableFilters = () => {
  const search = ref('');
  const filters = ref({
    selectedSubcontractors: []
  });

  const searchChanged = (event) => {
    search.value = event;
  };
  const subcontractorsChange = (event) => {
    filters.value.selectedSubcontractors = event;
  };

  return {
    search,
    filters,
    searchChanged,
    subcontractorsChange
  };
};
